import { Module, VuexModule, MutationAction, getModule, Mutation } from 'vuex-module-decorators';
import store from '@/store';
import { UserProfile } from '@/models/dexie/UserProfile';
import { UserProfileService } from '@/services/index';
import { UnitsMenuItem } from '@/models/general/UnitsMenuItem';

export interface IUserProfileStoreState {
    userProfile: UserProfile;
    userProfileLoaded: boolean;
}

@Module({ dynamic: true, store, name: 'userProfileStore' })
class UserProfileStoreModule extends VuexModule {
    public userProfile: UserProfile = new UserProfile();
    public userProfileLoaded: boolean = false;
    /**
     * Fetch user profile by email
     *
     * Note:
     * 'userProfile' are replaced by returned object
     * whose shape must be `{userProfile: [...]}`
     *
     * @param userId    The email of the user
     */
    @MutationAction({ mutate: ['userProfile'] })
    public async FetchUserProfile(userId: string) {
        const userProfile = UserProfileStore.GetUserProfile;
        if (userProfile.userId && userProfile.userId === userId) {
            UserProfileStore.SetUserProfileLoaded();
            return { userProfile };
        } else {
            const response: UserProfile = await UserProfileService.FetchUserProfile(userId);
            UserProfileStore.SetUserProfileLoaded();
            return { userProfile: response };
        }
    }

    @Mutation
    public ChangeProfileUnit(inUnit: UnitsMenuItem) {
        const oldUnit = this.userProfile.units.find((unit) => unit.unitIdentifier === inUnit.identifier);
        if (oldUnit !== undefined) {
            oldUnit.selectedValue = inUnit.selectedUnitFormat;
        } else {
            this.userProfile.units.push({ unitIdentifier: inUnit.identifier, selectedValue: inUnit.selectedUnitFormat });
        }
        UserProfileService.PutUserProfile(this.userProfile);
    }

    @Mutation
    public SetUserProfileLoaded() {
        this.userProfileLoaded = true;
    }

    /**
     * Getter for userProfile
     */
    get GetUserProfile() {
        return this.userProfile;
    }

    /**
     * Getter for userProfileLoaded
     */
    get GetUserProfileLoaded() {
        return this.userProfileLoaded;
    }
}

export const UserProfileStore = getModule(UserProfileStoreModule);
